import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaGooglePlay,
} from "react-icons/fa";
import "./Footer.css";
import whitens from "../assets/images/aiota_about_logo_white.png";
import google from "../assets/images/google-play.png";
import { Link } from "react-router-dom";

// ⭐ Import Material UI Icons
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";

const Footer = () => {
  const [totalVisitors, setTotalVisitors] = useState(0);

  useEffect(() => {
    const incrementVisitor = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASEURL}/increment`,
          { method: "POST" }
        );

        const data = await res.json();
        if (data.success) {
          setTotalVisitors(data.totalVisitors);
        }
      } catch (error) {
        console.error("Error fetching visitor count:", error);
      }
    };

    incrementVisitor();
  }, []);

  const visitorDigits = totalVisitors.toString().split("");

  return (
    <footer className="footer">
      <Container>
        <Row className="top-footer">
          <Col md={3} className="footer-logo d-flex flex-column align-items-start">
  <img src={whitens} alt="Logo" className="mb-3" />

  <div className="d-flex flex-row gap-2 w-100">
    {/* App Store */}
    <Button
      onClick={() =>
        window.open(
          "https://apps.apple.com/in/app/aiota/id6753784082",
          "_blank"
        )
      }
      className="d-flex align-items-center gap-2 px-3 py-2 w-100"
      style={{
        backgroundColor: "#fff",
        borderColor: "#fff",
        borderRadius: "10px",
        color: "#000",
        textTransform: "none",
      }}
    >
      <AppleIcon style={{ fontSize: "36px" }} />
      <div className="text-start lh-sm">
        <div style={{ fontSize: "10px" }}>Download on the</div>
        <div style={{ fontSize: "14px", fontWeight: 600 }}>
          App Store
        </div>
      </div>
    </Button>

    {/* Google Play */}
    <Button
      onClick={() =>
        window.open(
          "https://play.google.com/store/apps/details?id=com.inciem.aiotaapp&pcampaignid=web_share",
          "_blank"
        )
      }
      className="d-flex align-items-center gap-2 px-3 py-2 w-100"
      style={{
        backgroundColor: "#fff",
        borderColor: "#fff",
        borderRadius: "10px",
      
        textTransform: "none",
      }}
    >
      {/* <FaGooglePlay
  style={{
    fontSize: "26px",
    // background: "linear-gradient(45deg, #34A853, #FBBC05, #EA4335, #4285F4)",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
  }}
/> */}
<img src={google} alt="Google Play" style={{ width: "26px", height: "26px" }} />

      <div className="text-start lh-sm">
        <div style={{ fontSize: "10px",  color: "#000" }}>Get it on</div>
        <div style={{ fontSize: "14px",  color: "#000", fontWeight: 600 }}>
          Google Play
        </div>
      </div>
    </Button>
  </div>
</Col>


          <Col lg={6} className="important-links">
            <h5 className="text-center text-sm-start">Important Links</h5>
            <ul className="row text-center text-sm-start">
              <li className="col-sm-6">
                <Link
                  to="https://www.oticon2026.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  OTICON 2026
                </Link>
              </li>
              <li className="col-sm-6">
                <Link to="/wfot">WFOT</Link>
              </li>
              <li className="col-sm-6">
                <Link to="/terms-conditions">Apply Membership</Link>
              </li>
              <li className="col-sm-6">
                <Link to="/EDCCterms-conditions">Ergonomic Certification</Link>
              </li>
              <li className="col-sm-6">
                <Link to="/license-professional-status">License Verification</Link>
              </li>
              <li className="col-sm-6">
                <Link to="/about-aiota">About AIOTA</Link>
              </li>
              <li className="col-sm-6">
                <Link to="/Contact-Us">Contact us</Link>
              </li>
            </ul>
          </Col>

          <Col lg={3}>
            <div className="footer-box">
              <address className="footer-address">
                Plot No. 51, Kamdhenu Business Bay,
                <br />
                8th Floor, door no 801,
                <br />
                Sector 1, Juinagar East, Nerul,
                <br />
                Navi Mumbai, Maharashtra 400706
                <br />
                Phone : +91-8921852188
              </address>

              <div className="footer-icons">
                <a
                  href="https://www.facebook.com/people/AIOTA-All-India-Occupational-Therapists-Association/100078430662530/?ref=bookmarks#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </a>

                <a
                  href="https://x.com/AllOccupational"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter />
                </a>

                <a
                  href="https://www.linkedin.com/in/aiota-all-india-occupational-therapists-4195ab168/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </a>

                <a
                  href="https://www.youtube.com/channel/UCXalOShgAKp36dk8mlCnh0Q"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube />
                </a>
              </div>

             
              {/* ⭐ END STORE ICONS */}

            </div>
          </Col>
        </Row>

        <hr />
        <div className="bottom-footer">
          <div className="bottom-left">
            <p>© 2025 AIOTA. All Rights Reserved.</p>
          </div>

          <div className="bottom-right">
            <p>
              <a href="/privacy-policy">Privacy Policy</a> |{" "}
              <a href="/terms-of-service">Terms of Service</a>
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
